import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const SectionFields_Box_1 = styled.div`
  width: 100%;
  padding-inline: 8px;
  flex: 0 0 auto;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    width: var(--w-md);
  }
`;
